module.exports = __webpack_public_path__ + "assets/img/aiwriter-bus1.7d1aa59d.png";